import CoreBase from '../../../../services/engines/CoreBase';
import templateLoader from './TemplateLoader';

class ThemeInjector extends CoreBase {
    _name = 'ThemeInjector';

    /**
     * Loads a single theme body by rk.
     * @param {{ title: string, rk: string }} theme
     * @returns {string|null}
     */
    _loadTheme(theme) {
        const note = templateLoader.load(theme.rk);
        if (!note) {
            this.logError(`_loadTheme: not found — title=${theme.title} rk=${theme.rk}`);
            return null;
        }
        return note.body;
    }

    /**
     * Resolves all themes from templateJson.themes[] via rk,
     * joins CSS and injects into <head>.
     * Bails out if any theme fails to load.
     * @param {string} html
     * @param {object} templateJson
     * @returns {string|null} html with themes injected or null on failure
     */
    inject(html, templateJson) {
        const themes = templateJson?.themes ?? [];

        const cssParts = [];
        for (const theme of themes) {
            const css = this._loadTheme(theme);
            if (!css) return null;
            cssParts.push(css);
        }

        if (!cssParts.length) return html;

        return html.replace('</head>', `<style>${cssParts.join('\n')}</style>\n</head>`);
    }
}

const themeInjector = new ThemeInjector();
export default themeInjector;
